<template>
  <b-modal ref="career-fit-occupations" id="career-fit-occupations" class="career-fit-occupations" hide-footer
    size="xl">
    <template #modal-title>
      <div class="tile selected">
        <h3 class="tile-title">{{ selectedTitle }}</h3>
        <p class="tile-description">{{ selectedDescription }}</p>
        <span class="checkmark">✅</span>
      </div>
    </template>

    <div class="career-fit-occupations-card">
      <div class="career-fit-occupations">
        <!-- <b-row class="mb-3">
          <b-col cols="12" lg="12">
            <h5 class="occupations-location text-center">
              Location:
              <span class="font-weight-bold">
                {{ selectedZip || 'Not Specified' }}
              </span>
            </h5>
          </b-col>
        </b-row> -->
        <b-row class="mb-3">
          <b-col xs="12" lg="12">
            <b-input class="form-control" v-model="search" placeholder="Search Occupations in this Cluster"></b-input>
          </b-col>
        </b-row>
        <div class="position-relative">
          <div class="salary-level">(Salary Levels Nationwide)</div>
        </div>
        <div class="table-scroll mt-5">
          <table size="small" v-if="formatSalary(filteredOccupations[0].starting_salary) !== '$NaN'"
            class="table table-striped toolbar-list">
            <thead class="thead-dark purple-bg-table">
              <tr>
                <th @click="sortBy('occupation_name')" :class="{ active: currentSort === 'occupation_name' }">Occupation
                </th>
                <th>About</th>
                <th @click="sortBy('starting_salary')" :class="{ active: currentSort === 'starting_salary' }">
                  Starting Salary
                </th>
                <th @click="sortBy('median_salary')" :class="{ active: currentSort === 'median_salary' }">Median Salary
                </th>
                <th @click="sortBy('degree_required')" :class="{ active: currentSort === 'degree_required' }">Higher Ed
                  Required</th>
                <!-- <th @click="sortBy('job_security')" :class="{ active: currentSort === 'job_security' }">Job Security</th> -->
              </tr>
            </thead>
           
            <tbody>
              <tr v-for="(occupation, index) in filteredOccupations" :key="`${index}-${occupation.occupation_name}`">
                <td @click="chooseOccupation(occupation.occupation_name)" class="selet-occupation">
                  {{ occupation.occupation_name }}
                </td>
                <td>
                  <div class="tooltip-part">
                    <button class="tool"><i class="far fa-question-circle" aria-hidden="true"></i></button>
                    <div class="tool_data">
                      <OccupationComponent :title="occupation.occupation_name" />
                    </div>
                  </div>
                </td>
                <td>{{ formatSalary(occupation.starting_salary) }}</td>
                <td>{{ formatSalary(occupation.median_salary) }}</td>
                <td>{{ occupation.degree_required }}</td>
                <!-- <td>{{ occupation.job_security.trim().split(/\s+/)[0] }}</td> -->
              </tr>
            </tbody>
          </table>
          <div v-else class="cluster-loading d-flex flex-column align-items-center justify-content-center">
            <div class="loader-ai"></div>
            <p class="mb-0 mt-2">Loading, Please Wait...</p>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import OccupationComponent from '@/CareerFitOccupations/Occupation';
import occupation from '../CareerFit/occupation';

export default {
  props: {
    isOpen: Boolean,
    occupations: {
      type: Array,
      default: () => []
    },
    state: String,
    city: String,
    zip: String,
    age: Array,
    selectedZip: String,
    selectedCluster: String,
    selectedTitle: String,
    selectedDescription: String,
  },
  data() {
    return {
      search: "",
      currentSort: '',
      sortKey: "",
      sortAsc: true,
      enrichedOccupationsData: []
    };
  },
  components: {
    OccupationComponent,
  },
  computed: {
    filteredOccupations() {
      let result = [...this.enrichedOccupationsData.length ? this.enrichedOccupationsData : this.occupations];
      if (this.search) {
        result = result.filter(item =>
          item.occupation_name.toLowerCase().includes(this.search.toLowerCase())
        );
      }
      if (this.sortKey) {
        result.sort((a, b) => {
          let valA = a[this.sortKey];
          let valB = b[this.sortKey];

          // Handle numeric sorting correctly
          if (this.sortKey === 'starting_salary' || this.sortKey === 'median_salary') {
            valA = parseFloat(valA) || 0;
            valB = parseFloat(valB) || 0;
            return this.sortAsc ? valA - valB : valB - valA;
          }

          if (valA == null) valA = "";
          if (valB == null) valB = "";

          valA = valA.toString().toLowerCase();
          valB = valB.toString().toLowerCase();
          return this.sortAsc
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
        });
      }

      return result;
    }
  },
  methods: {
    formatSalary(salary) {
      if (!salary || salary === 0) return '0';
      // Format as currency
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(salary);
    },
    chooseOccupation(occupation_index) {
      this.closeModal();
      this.$emit('chooseOccupationAI', occupation_index);
    },
    closeModal() {
      this.$bvModal.hide('career-fit-occupations');
      this.$emit('close');
    },
    openModal() {
      this.$bvModal.show('career-fit-occupations');
    },
    sortBy(key) {
      this.currentSort = key;
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        if (key === "starting_salary")
          this.sortAsc = false;
        else
          this.sortAsc = true;
      }
    },
    async fetchSalaryData() {
      const currentYear = new Date().getFullYear();
      const headers = {
        'x-api-key': 'zeN7kb7YRU9N0DGv2M1Yr3wLMnZntYTX3hHl1yVp'
      };

      try {
        const enrichedOccupations = await Promise.all(this.occupations.map(async (occ) => {
          const request = {
            request_id: "test",
            location: this.zip,
            occupation: occ.occupation_name,
            apartment_room_count: "4",
            householdSize: this.age.length,
            birthYears: this.age.map((item) => currentYear - item).join(","),
          };

          try {
            const res = await this.$http.post("https://api.spendid.io/v2.0/area-costs-analysis", request, { headers });
            // const data = res.data.oew_by_location_area || {};
            let data = res.data.oew_by_location_national;
            // if(+res.data.oew_by_location_area.Median >= 0 && +res.data.oew_by_location_area["Low End"] >= 0)
            //   data = res.data.oew_by_location_area

            // else if(+res.data.oew_by_location_state.Median >= 0 && +res.data.oew_by_location_state["Low End"] >= 0)
            //   data = res.data.oew_by_location_state

            // else if(+res.data.oew_by_location_national.Median >= 0 && +res.data.oew_by_location_national["Low End"] >= 0)
            //   data = res.data.oew_by_location_national

            return {
              ...occ,
              starting_salary: data['Low End'] || 0,
              median_salary: data['Median'] || 0,
            };
          } catch (e) {
            // console.error(`Error fetching data for ${occ.occupation_name}:`, e);
            return {
              ...occ,
              starting_salary: 0,
              median_salary: 0
            };
          }
        }));

        this.enrichedOccupationsData = enrichedOccupations;
      } catch (error) {
        // console.error("Error in fetchSalaryData:", error);
      }
    }
  },
  async mounted() {
    await this.fetchSalaryData();
    this.sortBy('starting_salary')
  },
  watch: {
    occupations: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.fetchSalaryData();
        }
      }
    },
    zip() {
      this.fetchSalaryData();
    }
  }
};
</script>

<style>
#career-fit-occupations .modal-header .close {
  background: red;
  border-radius: 100px;
  width: 30px;
  height: 30px;
  margin-top: 10px;
  margin-right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  opacity: 1;
  text-shadow: none;
  color: #fff;
  font-weight: 400;
  font-size: 26px;
}
@media (max-width:767px) {
#career-fit-occupations .modal-header .close {
    width: 20px !important;
    height: 20px !important;
    font-size: 18px;
    position: absolute;
    top: -10px;
    right: 0;
}
}
</style>
<style scoped>
.occupations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
  padding: 1rem;
}

.occupation-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 1rem;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.occupation-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #333;
}

.occupation-info {
  margin-bottom: 1rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.tooltip-part {
  position: relative;
}

.tool {
  background: transparent;
  width: 30px;
  height: 30px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-size: 20px;
  opacity: 0.7;
}

.tool_data {
  display: none;
  position: absolute;
  width: 500px;
  overflow-y: auto;
  height: calc(100vh - 60vh);
  /* background: white;
  padding: 11px; */
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  top: 20px;
  left: 40px;
  z-index: 99;
}

.tooltip-part:hover>.tool_data {
  display: block;
}

.toolbar-list tbody tr:nth-last-child(8) .tool_data,
.toolbar-list tbody tr:nth-last-child(8)~tr .tool_data {
  top: initial;
  bottom: 0;
}

.darkmode .tool i {
  color: #eee;
}

.toolbar-list thead th {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='101' height='101' viewBox='0 0 101 101' preserveAspectRatio='none'><path d='M51 1 L76 24 L100 46 H1 L26 24 Z M51 100 L76 77 L100 55 H1 L26 77 Z' fill='%23ffffff'/></svg>");
  background-position: right .375rem center;
  padding-right: calc(.75rem + 1.8em);
  background-repeat: no-repeat;
  background-size: 16px;
  cursor: pointer;
  vertical-align: middle;
}

.toolbar-list>thead>tr>th:nth-child(2) {
  background-image: none;
}

.info-label {
  color: #666;
  font-weight: 500;
}

.info-value {
  color: #333;
  font-weight: 600;
}

.occupation-actions {
  display: flex;
  justify-content: space-between;
}

.occupation-actions .btn {
  flex-grow: 1;
}

.occupations-location {
  color: #494949;
  font-size: 1.1rem;
}

.selet-occupation:hover {
  background-color: lightblue;
  cursor: pointer
}

.tile.selected {
  background-color: #2ba195;
  border: none;
  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  padding: 15px;
  display: block !important;
  cursor: pointer;
  position: relative;
  height: 120px;
  width: 330px;
  box-sizing: border-box;
}

.tile.selected .tile-title {
  color: #FFFFFF;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.tile.selected .tile-description {
  color: #FFFFFF;
  font-size: 14px;
  margin: 0;
  line-height: 1.4;
}

.tile.selected .checkmark {
  position: absolute;
  top: 10px;
  right: 10px;
  display: block;
  color: #FFFFFF;
  font-size: 20px;
}

.purple-bg-table th {
  background-color: #9e36b3 !important;
  border-color: #9e36b3 !important;
}

.salary-level {
  margin-top: 10px;
  margin-bottom: 10px;
  color: #000;
  font-weight: 400;
  /* left: calc(50% + 100px);
  transform: translateX(-50%); */
}
.salary-level {
    position: absolute;
    top: -10px;
    right: 193px;
    display: inline-block;
    font-size: 21.3px;
    /* left: calc(50% + 100px);
    transform: translateX(-50%); */
}
@media only screen and (min-width:992px) and (max-width:1200px)  {
 .salary-level {
    right: 164px;
    font-size: 18.3px;
  }
}
/* @media only screen and (max-width: 600px) and (min-width: 400px) {...} */
@media (max-width:991px) {
.salary-level {
    right: 66px;
    font-size: 14px;
  }
  .toolbar-list thead th,
  .toolbar-list tbody td{
    font-size: 13px;
  }
}

.darkmode .salary-level {
  color: #ababab;
}
.toolbar-list thead th.active {
  background-color: #7a2e8b !important;
}
.table-scroll {
  height: calc(50vh - 45px);
  overflow-y: auto;
  /* margin-top: 45px; */
}
.table-scroll table thead {
  position: sticky;
  top: 0;
  z-index: 100;
}

/* @media all and (max-width: 1199px) {
  .salary-level {
    left: 52%;
  }
}

@media all and (max-width: 991px) {
  .salary-level {
    left: 50%;
  }
} */
</style>